<form [formGroup]="formGroup" (ngSubmit)="activateSkillRedirection()">
   <div>
      <kendo-textbox
         #inputElement
         *ngIf="(permittedSkillDiversions$ | async).length == 0"
         formControlName="diversionTarget"
         fxFlex="1 1 *"
         [placeholder]="'samwin.skill-diversion.placeholder' | translate"
      ></kendo-textbox>
      <kendo-combobox
         #inputElement
         *ngIf="(permittedSkillDiversions$ | async).length > 0"
         formControlName="diversionTarget"
         fxFlex="1 1 *"
         [data]="filteredSkillDiversions$ | async"
         [valueField]="'number'"
         [textField]="'number'"
         [valuePrimitive]="true"
         [filterable]="true"
         (filterChange)="userFilterChanged($event)"
         [allowCustom]="'CcoPermMayFreelyDivertSkill' | isFeatureEnabled$ | async"
         [suggest]="true"
         [placeholder]="'samwin.skill-diversion.placeholder' | translate"
      >
         <ng-template kendoComboBoxNoDataTemplate> </ng-template>
         <ng-template kendoComboBoxItemTemplate let-dataItem>
            <div
               *ngIf="dataItem.name?.length > 0"
               innerHtml="{{ dataItem.name | highlightText$: userFilter$ | async }} ({{
                  dataItem.number | highlightText$: userFilter$ | async
               }})"
            ></div>
            <div
               *ngIf="dataItem.name?.length == 0"
               innerHtml="{{ dataItem.number | highlightText$: userFilter$ | async }}"
            ></div>
         </ng-template>
      </kendo-combobox>

      <button
         kendoButton
         kendoTooltip
         type="submit"
         [disabled]="!formGroup.valid"
         fxFlex="1 1 auto"
         [title]="'samwin.skill-diversion.forward' | translate"
      >
         <fa-icon [icon]="redirectionIcon"></fa-icon>
      </button>
   </div>
</form>
